<template>
  <div class="banner-tab-container">
    <div
      class="banner-box"
      :style="{ backgroundImage: 'url( ' + banner + ')' }"
    >
      <div class="banner-title">{{bannerText}}</div>
      <div class="arrow-box">
        <i class="iconfont-icon el-icon-bottom"></i>
      </div>
    </div>
    <div class="tab-box" v-if="isShowTab">
      <div
        class="tab-list"
        v-for="(item,index) in tabList"
        :key="index"
        @click="goTab(item,index)"
        :class="tabActive === index?'tab-active':''"
      >{{item.name}}</div>
    </div>
  </div>
</template>
<script>
import bannerImg from '@/assets/img/banner.png';

export default {
  name: 'bannerImg',
  props: {
    bannerText: '',
    isShowTab: true,
    bannerInfo: {},
    bannerCover: ''
  },
  data() {
    return {
      banner: bannerImg,
      tabList: [
        {
          name: '课程列表',
          url: 'courseList',
          index: 0
        },
        {
          name: '在线考试',
          url: 'onlineExam',
          index: 1
        },
        {
          name: '远程教育',
          url: 'remoteEducation',
          index: 2
        },
        {
          name: '柏瑞康书斋',
          url: 'studyRoom',
          index: 3
        },
        {
          name: '学校风采',
          url: 'schoolShow',
          index: 4
        },
        {
          name: '个人中心',
          url: 'personalCenter',
          index: 5
        }
      ],
      tabActive: 0
    };
  },
  created() {
    if (this.isShowTab) {
      this.setTabindex();
    }
  },
  methods: {
    setTabindex() {
      const name = this.$router.history.current.name;
      console.log(name);
      if (
        name === 'myCourse' ||
        name === 'myCard' ||
        name === 'commodityOrder' ||
        name === 'joinUs' ||
        name === 'editInfo' ||
        name === 'message' ||
        name === 'playRecord'
      ) {
        this.tabActive = 5;
        return;
      }
      let indexValue = this.tabList.filter((item, index) => {
        return item.url === name;
      });
      console.log(indexValue);
      if (indexValue[0].index) {
        this.tabActive = indexValue[0].index;
      }
    },
    goTab(item, index) {
      console.log(item);
      if (this.$router.history.current.name !== item.url) {
        this.$router.push({ name: item.url });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.banner-box {
  width: 100%;
  height: 780PX;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  animation: img 3s;
  // opacity: 0.8;

  @keyframes img {
    0% {
      opacity: 0.6;
      transform: scale(1.2);
    }

    100% {
      opacity: 0.8;
      transform: scale(1);
    }
  }
  .banner-title {
    position: relative;
    padding: 290PX 0 52PX 290PX;
    font-size: 55PX;
    color: #ffffff;
    animation: title 1.5s;
  }
  @keyframes title {
    from {
      top: -10PX;
      left: 0;
      transform: translateX(-200PX);
      opacity: 0;
    }
    to {
      top: 0;
      transform: translateX(0);
      opacity: 1;
    }
  }
  .arrow-box {
    width: 66PX;
    height: 66PX;
    margin-left: 290PX;
    text-align: center;
    border: 1PX solid rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    animation: arrow 1.5s;
  }
  @keyframes arrow {
    0% {
      transform: translate(-100PX, 500PX);
      opacity: 0;
    }
    100% {
      top: 0;
      transform: translateY(0);
      opacity: 1;
    }
  }
  .iconfont {
    font-size: 30PX;
    line-height: 66PX;
    color: rgba(255, 255, 255, 0.9);
  }
}

.tab-box {
  display: flex;
  // justify-content: space-between;
  padding-left: 290PX;
  font-size: 14PX;
  color: #2c2c2c;
  border-bottom: 1PX solid #ededed;
  background-color: #ffffff;
  .tab-list {
    padding: 32PX 0;
    margin-right: 6%;
    border-bottom: 3PX solid transparent;
    cursor: pointer;
    &:hover {
      color: #f6ab2b;
      border-bottom: 3PX solid #f6ab2b;
    }
  }
  .tab-active {
    color: #f6ab2b;
    border-bottom: 3PX solid #f6ab2b;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bannerImg.vue